export const SCHEDULE = {
  SESSION_GENERATE_REQUEST: "SCHEDULE_SESSION_GENERATE_REQUEST",
  SESSION_GENERATE_SUCCESS: "SCHEDULE_SESSION_GENERATE_SUCCESS",
  SESSION_GENERATE_ERROR: "SCHEDULE_SESSION_GENERATE_ERROR",
  SESSION_GENERATE_RESET: "SCHEDULE_SESSION_GENERATE_RESET"
}